export function cleanurlOfParams(url) {
  const decoded = decodeURI(url);
  const earl = new URL(decoded);
  const params = earl.searchParams;
  if (params.has('s') && params.has('c') && params.has('f')) {
    return earl.origin + earl.pathname;
  }

  return url;
}

export function createImageAttrs(primaryImg, fullFallbackInstance) {
  const url = cleanurlOfParams(primaryImg.fallback);
  const attrs = {
    url: url,
    medium: 'image',
  };

  if (fullFallbackInstance?.height) attrs.height = fullFallbackInstance.height;
  if (fullFallbackInstance?.width) attrs.width = fullFallbackInstance.width;
  if (fullFallbackInstance?.imageType)
    attrs.type = `image/${fullFallbackInstance.imageType.replace(
      /jpg/,
      'jpeg'
    )}`;

  let mc = '';
  Object.keys(attrs).forEach((ky) => (mc += `${ky}="${attrs[ky]}" `));
  return mc.trim();
}

export function createHtmlImageAttrs(primaryImg, fullFallbackInstance) {
  const url = cleanurlOfParams(primaryImg.fallback);
  const attrs = {
    src: url,
  };

  if (fullFallbackInstance?.height) attrs.height = fullFallbackInstance.height;
  if (fullFallbackInstance?.width) attrs.width = fullFallbackInstance.width;
  if (primaryImg?.shortCaption) attrs.alt = primaryImg.shortCaption;

  let mc = '';
  Object.keys(attrs).forEach((ky) => (mc += `${ky}="${attrs[ky]}" `));
  return mc.trim();
}
